// src/helpers/open-app-settings.ts
// Opens the native app settings page so the user can re-enable denied permissions.

import { isNative } from '../platform';

export async function openAppSettings(): Promise<void> {
  if (!isNative()) return;
  const { NativeSettings, AndroidSettings, IOSSettings } = await import('capacitor-native-settings');
  await NativeSettings.open({
    optionAndroid: AndroidSettings.ApplicationDetails,
    optionIOS: IOSSettings.App,
  });
}
